import { tv } from 'tailwind-variants'

export const progress = tv({
  slots: {
    container: 'h-1 w-full overflow-hidden bg-ui-grey-50',
    bar: 'h-full bg-brand-dark ease-in-out web:transition-all web:duration-500',
  },
  variants: {
    isStepper: {
      true: {
        bar: 'h-full bg-ui-green ease-in-out web:transition-all web:duration-500',
      },
    },
    rounded: {
      true: {
        container: 'rounded-full',
      },
    },
  },
})
